const mutations = {
  authenticate (state) {
    state.authenticated = true
  },
  logout (state) {
    state.authenticated = false
    state.authUser = null
  },
  authUser (state, user) {
    state.authUser = user
  }
}

export default mutations
